import { registerComponent } from '@gig/magic-common';
import TooltipComponent from './tooltip.vue.js';

var Tooltip = registerComponent(TooltipComponent);

export { Tooltip };
